export default __webpack_public_path__ + "static/media/howler_audio_test.12f1cf4c.ogg";